<template>
  <div class="guarantee">
    <project-guarantee-item :guarantee-text="guaranteeText" />
  </div>
</template>

<script>
import ProjectGuaranteeItem from "@/components/main/aboutProject/modules/ProjectGuaranteeItem.vue";

export default {
  name: "project-guarantee",
  components: { ProjectGuaranteeItem },
  props: {
    guaranteeText: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.guarantee {
  display: flex;
  flex-direction: column;
  gap: 17px;
}
</style>
